import type { BoggleChallengeCoreInfo } from './types'

export function getChallengeMinWordLengthInfo(
  minWordLength: number,
): BoggleChallengeCoreInfo<number> {
  if (minWordLength <= 3) {
    return {
      id: 'min-word-standard',
      tierLabel: 'Standard',
    }
  }

  if (minWordLength === 4) {
    return {
      id: 'min-word-longer',
      tierLabel: 'Longer words',
    }
  }

  return {
    id: 'min-word-longest',
    tierLabel: 'Longest gate',
  }
}
